"use strict";
(()=>{
  var p=class{
    constructor(){
      this.$parent=document.querySelector(".as-region-selector");
      this.$zoneData=document.querySelector(".as-zones-data");
      this.$regionData=document.querySelector(".as-regions-data");
      this.$localesData=document.querySelector(".as-selector-config-data");
      this.$settingsData=document.querySelector(".as-customize-app-settings-data");
      this.$alternateLinks=document.querySelectorAll('link[rel="alternate"]');
      
      if(!this.$parent||!this.$regionData)return;
      
      this.$data={};
      this.$settings={};
      this.$showModal=false;
      this.$alternateLinksArray=[];
      this.$stores=this.$parent.querySelector(".as-stores-wrap");
      this.$selectedRegionCookie="selectedRegion";
      this.$host=window.location.host;
      this.$path=window.location.pathname;
      this.$targetRegion={};
      this.$selectorModal=this.$parent.querySelector(".as-selector-modal");
      this.$selectorDropdown=this.$parent.querySelector(".as-selector-dropdown");
      
      this.init()
    }
    
    init(){
      this.handleMetaData();
      this.initSelectorStatus()
    }
    
    handleMetaData(){
      var e,a;
      this.$data.areas=this.$zoneData&&JSON.parse(this.$zoneData.innerHTML);
      this.$data.areas=this.$data.areas.reverse();
      this.$data.regions=this.$regionData&&JSON.parse(this.$regionData.innerHTML);
      
      const t=JSON.stringify({locales:[]});
      this.$data.locales=(a=JSON.parse(this.$localesData&&((e=JSON.parse(this.$localesData.innerHTML).find(s=>s.configType===2))==null?void 0:e.content)||t))==null?void 0:a.locales;
      this.$settings=this.$settingsData&&JSON.parse(this.$settingsData.innerHTML).settings;
      
      this.$alternateLinks.forEach(s=>{
        let i=s.href;
        if(!i.endsWith("/")){
          i=i+"/"
        }
        const r=new URL(i);
        const n=r==null?void 0:r.pathname;
        const o=n.split("/");
        const c="/"+o[1]+"/";
        const $=/^\/[^/]+\/$/;
        const d=c.match($);
        
        if(d){
          const h=d[0];
          if(!(h==null?void 0:h.match(/(pages|products|collections|account|cart|search|blogs|404|policies)/))){
            this.$alternateLinksArray.push(h)
          }
        }
      });
      
      this.$alternateLinksArray.forEach(s=>{
        if(!this.$path.endsWith("/")){
          this.$path=this.$path+"/"
        }
        if(this.$path.includes(s)){
          this.$path=this.$path.replace(`${s}`,"/")
        }
      });
      
      if(this.$path.length>1){
        this.$data.regions.map(s=>{
          var i;
          if(document.body.dataset.template!=="404"){
            if(s.websiteUrl.endsWith("/")){
              s.websiteUrl=s.websiteUrl+((i=this.$path)==null?void 0:i.substring(1))
            }else{
              s.websiteUrl=s.websiteUrl+this.$path
            }
          }
        })
      }
      
      this.$data.areas.map(s=>{
        s.regions=this.$data.regions.filter(i=>i.zoneId===s.id)
      })
    }
    
    initSelectorStatus(){
      if(this.$settings&&!this.$settings.enableSelector){
        this.$parent.remove();
        return
      }else{
        this.$parent.classList.remove("d-none")
      }
      
      this.initStyle();
      this.renderSelectedStore();
      this.sortRegionList();
      this.renderCopyWritting();
      this.renderRegionList();
      this.initOtherSettings();
      this.initSelector()
    }
    
    initStyle(){
      var s;
      // 导航栏地球入口 + 弹窗方案（momax 风格）：始终使用弹窗模式
      this.$wrap=this.$selectorModal;
      this.$selectorModal.classList.remove("d-none");
      if(this.$selectorDropdown&&this.$selectorModal) this.$selectorDropdown.remove();
      this.$showModal=true;
      this.$wrap.classList.add((s=this.$settings)==null?void 0:s.selectorModalStyle)
    }
    
    sortRegionList(){
      var t;
      if(this.$showModal&&((t=this.$settings)==null?void 0:t.showArea)){
        this.$data.areas.map(e=>{
          var a;
          (a=e.regions)==null?void 0:a.sort(this.sortData("name"))
        })
      }
      this.$data.regions.sort(this.sortData("name"))
    }
    
    sortData(t){
      return function(e,a){
        if(e[t]>a[t]){
          return 1
        }
        if(e[t]<a[t]){
          return-1
        }
        return 0
      }
    }
    
    renderCopyWritting(){
      if(!this.$showModal)return;
      let t=this.$data.locales.find(e=>{
        var a;
        return e.isoCode==((a=this.$targetRegion)==null?void 0:a.languageIsoCode)
      });
      t&&t.title&&(this.$wrap.querySelector(".as-modal-title").textContent=t==null?void 0:t.title)
    }
    
    renderRegionList(){
      var t;
      if(this.$showModal){
        if((t=this.$settings)==null?void 0:t.showArea){
            
      const withRegionContainer = this.$wrap.querySelector(".as-modal-region-list-with-region");
      if(withRegionContainer) withRegionContainer.innerHTML = '';
      
          this.$data.areas.map((e,a)=>{
            var n;
            let s=document.createElement("div");
            let i=this.$parent.querySelector(".as-modal-list-with-area-template").innerHTML.replace(/#{area}/g,e.name).replace(/#{index}/g,a);
            s.innerHTML=i;
            let r=s.querySelector(".as-regions-wrap");
            (n=e.regions)==null?void 0:n.map(o=>{
              var c=document.createElement("li");
              c.classList.add("col");
              const $=o.isoCode.toUpperCase()==="JP";
              const d=$?"日本語":o.languageLocalName||o.languageName;
              let h=this.$parent.querySelector(".as-region-list-template").innerHTML.replace("#{url}",o.websiteUrl).replace("#{region}",o.localName||o.name).replace("#{language}",d).replace(/#{isoCode}/g,o.isoCode.toUpperCase());
              c.innerHTML=h;
              r.appendChild(c)
            });
            this.$wrap.querySelector(".as-modal-region-list-with-region").appendChild(s)
          });
          this.initCollapse()
        }else{
            const withoutRegionContainer = this.$wrap.querySelector(".as-modal-region-list-without-region");
      if(withoutRegionContainer) withoutRegionContainer.innerHTML = '';

         this.$data.regions.map(e=>{
            let a=document.createElement("li");
            a.classList.add("col");
            let s=this.$parent.querySelector(".as-region-list-template").innerHTML;
            const i=e.isoCode.toUpperCase()==="JP";
            const r=i?"日本語":e.languageLocalName||e.languageName;
            let n=s.replace("#{url}",e.websiteUrl).replace("#{region}",e.localName||e.name).replace("#{url}",e.websiteUrl).replace("#{language}",r).replace(/#{isoCode}/g,e.isoCode.toUpperCase());
            a.innerHTML=n;
            withoutRegionContainer.appendChild(a)
      })
        }
      }else{
        let e=this.$parent.querySelector(".as-dropdown-lists");
        if(!e)return;
         e.innerHTML = '';
        this.$data.regions.map(a=>{
          let s=document.createElement("li");
          let i=this.$parent.querySelector(".as-list-html").innerHTML;
          const r=a.isoCode.toUpperCase()==="JP";
          const n=r?"日本語":a.languageLocalName||a.languageName;
          let o=i.replace("#{url}",a.websiteUrl).replace("#{region}",a.localName||a.name).replace("#{language}",n).replace(/#{isoCode}/g,a.isoCode.toUpperCase());
          s.innerHTML=o;
          e.appendChild(s)
        })
      }
    }
    
    initCollapse(){
      let t=this.$parent.querySelectorAll(".as-collapse-btn");
      t.forEach(e=>{
        e.addEventListener("click",a=>{
          e.classList.toggle("collapsed");
          e.ariaExpanded=="true"?e.ariaExpanded="false":e.ariaExpanded="true";
          e.nextElementSibling.classList.toggle("show")
        })
      })
    }
    
    getCookie(t){
      let e=document.cookie.match(new RegExp("(^| )"+t+"=([^;]+)"));
      if(e)return e[2]
    }
    
    // 🔧 修改后的 renderSelectedStore 函数 - 支持路径匹配
    renderSelectedStore(){
      var r,n,o,c,$,d,h;
      let t=this.$wrap.querySelector(".as-selected-store");
      let e=this.$wrap.querySelector(".as-selected-language");
      let a=this.$wrap.querySelector(".as-featured-flag");
      let s;
      let i;
      
      // 获取当前完整路径
      const currentPath = window.location.pathname;
      
      // 先检查 cookie
      if(this.getCookie(this.$selectedRegionCookie)){
        i=this.$data.regions.find(l=>l.isoCode.toUpperCase()==this.getCookie(this.$selectedRegionCookie));
        if(i){
          try{
            const cookieUrl = new URL(i.websiteUrl);
            const cookiePath = cookieUrl.pathname;
            // 检查 URL 的 host 和 path 是否都匹配
            if(cookieUrl.host == this.$host && currentPath.startsWith(cookiePath.replace(/\/$/, ''))){
              s=true
            }
          }catch(l){
            s=false
          }
        }
      }
      
      // 如果 cookie 不匹配,则根据当前 URL 路径查找
      if(!s){
        // 🔑 关键修改:按路径长度排序,优先匹配最长的路径
        const sortedRegions = this.$data.regions.slice().sort((a, b) => {
          try {
            const pathA = new URL(a.websiteUrl).pathname;
            const pathB = new URL(b.websiteUrl).pathname;
            return pathB.length - pathA.length; // 降序排列,最长的在前
          } catch(e) {
            return 0;
          }
        });
        
        // 查找匹配的 region
        this.$targetRegion = sortedRegions.find(l => {
          try {
            const regionUrl = new URL(l.websiteUrl);
            const regionPath = regionUrl.pathname.replace(/\/$/, ''); // 移除末尾斜杠
            const currentPathNormalized = currentPath.replace(/\/$/, '');
            
            // 检查 host 匹配且路径匹配
            return regionUrl.host == this.$host && 
                   (currentPathNormalized === regionPath || 
                    currentPathNormalized.startsWith(regionPath + '/'));
          } catch(e) {
            return false;
          }
        });
        
        // 如果还是找不到,使用默认的 isRecommended
        if(!this.$targetRegion) {
          this.$targetRegion = this.$data.regions.find(l=>l.isRecommended) || this.$data.regions[0];
        }
      } else {
        this.$targetRegion = i;
      }
      
      // 显示选中的区域
      t.textContent=((n=this.$targetRegion)==null?void 0:n.localName)||((o=this.$targetRegion)==null?void 0:o.name);
      
      if(((c=this.$targetRegion)==null?void 0:c.isoCode.toUpperCase())==="JP"){
        e.textContent="( 日本語 )"
      }else{
        e.textContent=`( ${(($=this.$targetRegion)==null?void 0:$.languageLocalName)||((d=this.$targetRegion)==null?void 0:d.languageName)} )`
      }
      
      a.classList.add(`sc-${(h=this.$targetRegion)==null?void 0:h.isoCode.toUpperCase()}`)
    }
    
    initOtherSettings(){
      var t,e;
      if(!((t=this.$settings)==null?void 0:t.showLanguage)){
        this.$parent.classList.add("no-language")
      }
      if(!((e=this.$settings)==null?void 0:e.showFlag)){
        this.$parent.classList.add("use-default-flag")
      }
    }
    
    initSelector(){
      this.$storeItem=this.$parent.querySelectorAll(".as-store");
      Array.from(this.$storeItem).map(t=>{
        t.addEventListener("click",()=>{
          if(document.domain.split(".").slice(-2).join(".")!=="myshopify.com"){
            if(t.dataset.regionCode!=="MY"){
              document.cookie=`${this.$selectedRegionCookie}=${t.dataset.regionCode};path=/;domain=${document.domain.split(".").slice(-2).join(".")}`
            }else{
              document.cookie=`${this.$selectedRegionCookie}=;path=/;domain=${document.domain.split(".").slice(-2).join(".")};expires=Thu, 01 Jan 1970 00:00:00 UTC;`
            }
          }else{
            document.cookie=`${this.$selectedRegionCookie}=${t.dataset.regionCode};path=/`
          }
        })
      })
    }
  };
  
  new p;
})();
